exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5e303b1e] .el-card__body,[data-v-5e303b1e] .el-tabs{height:100%}[data-v-5e303b1e] .el-tabs__content{height:calc(100% - 54px)!important;position:inherit}[data-v-5e303b1e] .el-tabs__content .el-tab-pane{height:100%}", ""]);

// exports
